import { Injectable } from '@angular/core';
import { SecureApi } from '../../core/secure.api';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class QuestionnairesService {

    constructor(public secureApi: SecureApi) {
    }

    getSelfEvaluationByPatient(id: number) {
        return this.secureApi.get('patient/self-evaluation-by-patient/' + id);
    }

    archiveQuestionnaires(id, showInFuture) {
        return this.secureApi.get('patient/archive/' + id + '/' + showInFuture);
    }

    deleteQuestionnaires(id) {
        return this.secureApi.delete('patientQuestionnaires/delete/' + id);
    }

    sendReminder(patientId, questionnaireId, email, content, dueDate, templateTranslationId,
        addDisclaimer,
        disclaimerText,
        emailSubject, emailHeader) {
        let paramBuilder = new URLSearchParams();
        paramBuilder.append('patient_id', patientId);
        paramBuilder.append('patient_questionnaire_id', questionnaireId);
        paramBuilder.append('email', email);
        paramBuilder.append('content', content);
        paramBuilder.append('template_translation_id', templateTranslationId);
        paramBuilder.append('disclaimer_text', disclaimerText);
        paramBuilder.append('add_disclaimer', addDisclaimer);
        paramBuilder.append('email_subject', emailSubject);
        paramBuilder.append('email_header', emailHeader);
        paramBuilder.append('due_date', dueDate);

        let modelProperties = paramBuilder.toString();
        let body = modelProperties;

        return this.secureApi.post('patient/reminder', body);
    }

    search(term: string, roleId: number) {
        return this.secureApi.get('questionnaires/search/' + term)['items'];
    }

    read(id: number, type: string) {
        return this.secureApi.get('questionnaires/read/' + id + '/' + type);
    }

    openQuestionnaire(id: number, type: string) {
        let body = 'questionnaire_id=' + id + '&type=' + type;

        return this.secureApi.post('questionnaire/open', body, true);
    }

    openQuestionnaireEditMode(id: number, type: string, cloneOnly : number = 0) {
        let body = 'questionnaire_id=' + id + '&type=' + type + '&clone_only=' + cloneOnly;

        return this.secureApi.post('questionnaire/open-edit-mode', body, true);
    }

    saveComment(patientId: number, questionnaireId: number, comment: string) {
        let body = 'patient_id=' + patientId + '&id=' + questionnaireId + '&comment=' + comment;
        return this.secureApi.put('patient-questionnaire/comment', body, true);
    }
}
